import { Component, input } from '@angular/core';

import { DetailsValueComponent } from '@iw/common';

import { Advcash, WithdrawalReq } from '../../../entities';

@Component({
  selector: 'iw-advcash-details',
  imports: [DetailsValueComponent],
  templateUrl: './advcash-details.component.html',
  styleUrl: './advcash-details.component.scss',
})
export class AdvcashDetailsComponent {
  withdrawalInfo = input.required<WithdrawalReq>();

  get details(): Advcash {
    return this.withdrawalInfo().details as Advcash;
  }
}
